// extracted by mini-css-extract-plugin
export default {"label":"InputText_label__bUI55"};